/* eslint-disable import/prefer-default-export */
import type { IScannerDetails } from '../scanStations/screenless/ScannerInterfaces';
import type ICompanyContactDetails from './company/CompanyInterfaces';
import type { IStoreDetails, IStoreOptions } from './store/StoreInterfaces';

export const emptyCompanyContactDetails = (): ICompanyContactDetails => ({
  companyId: '',
  name: '',
  email: '',
  address1: '',
  city: '',
  state: '',
  zipCode: '',
  tags: [],
});

export const emptyStoreOptions = (): IStoreOptions => ({
  active: false,
  estimatesByEmail: false,
  estimatesToCustomer: false,
  labelForRTVs: false,
  mustHaveQC: false,
  printEstimateWith: false,
  retailerRepairStore: false,
});

export const emptyStoreDetails = (storeIdParam: string | null): IStoreDetails => ({
  companyName: '',
  storeId: storeIdParam ?? '',
  name: '',
  storeNumber: '',
  email: '',
  address1: '',
  city: '',
  state: '',
  zipCode: '',
  tags: [],
  storeOptions: {
    active: false,
    estimatesByEmail: false,
    estimatesToCustomer: false,
    labelForRTVs: false,
    mustHaveQC: false,
    printEstimateWith: false,
    retailerRepairStore: false,
  },
});

export const emptyScannerDetails = (): IScannerDetails => ({
  name: '',
  serialNumber: '',
  ipAddress: '',
  macAddress: '',
  location: { label: '', value: '' },
});
